import styled from 'styled-components';

export const variables = {
  colors: {
    purple: '#a16ee9',
  },
  constants: {
    navbarHeight: 60,
    maxWidth: 1500,
  },
};

export const Container = styled.div`
  max-width: ${variables.constants.maxWidth}px;
  width: calc(100% - 40px);
  margin: 20px auto 0 auto;
  border-radius: 10px;
  background-color: hsl(var(--card));
  color: hsl(var(--card-foreground));
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
